import {Component, Input} from '@angular/core';
import {IBaseComponent} from '../../../../../sdk/src/components/ibase/ibase.component';
import {CpmCTaskApiModel} from '../../../../../gen/cpm-c-api-ts/src/models/c-customer/cpmc-task.api-model';
import {PrimeNgImportsModule} from '../../../../../sdk/src/prime-ng-imports';
import {CpmCTaskApiService} from '../../../../../gen/cpm-c-api-ts/src/services/c-customer/cpmc-task.api-service';
import {firstValueFrom} from 'rxjs';

/**
 * Task chat component
 */
@Component({
    selector: 'app-task-chat',
    templateUrl: './task-chat.component.html',
    imports: [PrimeNgImportsModule]
})
export class TaskChatComponent extends IBaseComponent {
    protected _currentTask?: CpmCTaskApiModel;

    // ===============================================================
    // ===============================================================

    @Input()
    public set currentTaskUUID(value: string | undefined) {
        this.showLoading = true;
        this._currentTask = undefined;

        if (value === null || value === undefined) {
            this.showLoading = false;
            return;
        }

        this.loadTask(value);
    }

    // ===============================================================
    // ===============================================================

    /**
     * On ready (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onReady(): Promise<void> {}
    /**
     * On destroy (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onDestroy(): Promise<void> {}

    // ===============================================================
    // ===============================================================

    /**
     * Load task by UUID
     * @param taskUUID UUID of the task to load
     */
    protected async loadTask(taskUUID: string) {
        this._currentTask = await firstValueFrom(CpmCTaskApiService.getTaskByUUID(taskUUID));

        // todo

        this.showLoading = false;
    }
}
